import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromClients from './clients.reducer';
import { ClientsEffects } from './clients.effects';
import { ClientsFacade } from './clients.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromClients.CLIENTS_FEATURE_KEY,
      fromClients.reducer
    ),
    EffectsModule.forFeature([ClientsEffects]),
  ],
  providers: [ClientsFacade],
})
export class ClientsStateModule {}
